import { deleteCookie, getCookie, setCookie } from 'cookies-next';

import { WPUser } from '@/types';

export async function signOut({ callbackUrl = '/' } = {}) {
	try {
		// Clear the JWT token
		deleteCookie('token'); // Removes the token cookie

		// Redirect to the callback URL
		window.location.href = callbackUrl;

		// If the URL contains a hash, the browser might not reload, so we force a reload
		if (callbackUrl.includes('#')) {
			window.location.reload();
		}
	} catch (error) {
		console.error('Error during sign-out:', error);
	}
}

export async function fetchUserData(token?: string): Promise<WPUser> {
	// If no token is passed, attempt to retrieve it from cookies
	const authToken = token || getCookie('token');

	if (!authToken) throw new Error('User is not authenticated, no token provided');

	const response = await fetch('https://sebastiangrantcdn.com/stone/wp-json/wp/v2/users/me', {
		headers: {
			Authorization: `Bearer ${authToken}`,
		},
	});

	if (!response.ok) {
		throw new Error('Failed to fetch user data');
	}
	return await response.json();
}

export async function fetchUserPosts(authorID: number): Promise<any> {
	const token = getCookie('token'); // Retrieve token from cookies
	if (!token) throw new Error('User is not authenticated');

	const response = await fetch(`https://sebastiangrantcdn.com/stone/wp-json/wp/v2/posts?author=${authorID}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	if (!response.ok) {
		throw new Error('Failed to fetch posts for user');
	}
	return await response.json();
}

export async function fetchFeaturedImage(mediaID: number): Promise<string | null> {
	if (mediaID === 0) return null; // No featured image

	const token = getCookie('token'); // Retrieve token from cookies
	if (!token) throw new Error('User is not authenticated');

	const response = await fetch(`https://sebastiangrantcdn.com/stone/wp-json/wp/v2/media/${mediaID}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	if (!response.ok) {
		console.error("Failed to fetch featured image data");
		return null;
	}
	const mediaData = await response.json();
	return mediaData.source_url || null; // Return the URL of the image
}

// Function to set the token cookie, e.g., after login
export function setTokenCookie(token: string) {
	setCookie('token', token, { maxAge: 60 * 60 * 24 }); // Set token cookie for 1 day
}
